// extracted by mini-css-extract-plugin
export default {"riskScoreContainer":"nohRXtICquMqle52fo3D","placeholderBoxes":"SJnykGHgyTtNmqJrkCue"};